const draggable = "_35sd1d2b9ta";

export { draggable };
import "./atom.draggable.style.linaria.module.css";
//# sourceMappingURL=atom.draggable.style.js.map
